<template>
  <v-container id="data-table-guias" class="py-0 px-2">
    <v-row>
      <v-col class="text-left px-0 py-6" cols="6">
        <h1 style="color: #430f4a">Procedimentos e Exames Realizados</h1>
      </v-col>
      <v-col class="text-right px-1" cols="6">
        <v-spacer></v-spacer>
        <v-btn
          height="30px"
          class="ml-3"
          small
          color="primary"
          depressed
          outlined
          @click="showopen()"
        >
          critícas
        </v-btn>
        <v-btn
          height="30px"
          class="ml-3"
          small
          color="primary"
          depressed
          outlined
          @click="deleteItems('exames')"
        >
          excluir despesa
        </v-btn>
      </v-col>
      <v-col class="px-0 py-0" cols="12">
        <v-data-table
          v-model="select"
          :headers="header"
          :items="list"
          :items-per-page="itemsPerPage"
          :page.sync="page"
          hide-default-footer
          ref="examesListTable"
          class="lotesListTable"
          min="-1"
          max="15"
          show-select
          dense
          @click:row="selectLine"
          @page-count="pageCount = parseInt($event, 10)"
          @toggle-select-all="selecionaTodos"
          @item-selected="selecaoUnica"
        >
          <template v-slot:item.selected="{ item }">
            <v-simple-checkbox v-model="item.selected"></v-simple-checkbox>
          </template>

          <template v-slot:item.dataExecucao="{ item }">
            <span
              v-if="item.id != id_list"
              >{{ item.dataExecucao | formatDate }}
            </span>
            <v-menu
              v-else
              ref="dt"
              v-model="dt"
              :close-on-content-click="true"
              transition="scale-transition"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="item.dateFormatted"
                  dense
                  :return-value.sync="item.dateFormatted"
                  v-mask="'##/##/####'"
                  format="DD/MM/YYYY"
                  placeholder="DD/MM/YYYY"
                  label
                  outlined
                  style="
                    font-size: 12px;
                    height: 32px;
                    margin: 8px 0px 8px;
                    width: 105px;
                  "
                  
                  v-bind="attrs"
                  v-on="on"
                  append-icon="mdi-calendar-blank"
                  @focus="item.dateFormatted = formatDate(item.dataExecucao)"
                  @blur="item.dataExecucao = parseDate(item.dateFormatted)"
                  @change="marcarLinha(item, 'examesListTable');"
                  :rules="[formRules.typeDateFormated]"
                ></v-text-field>
              </template>
              <v-date-picker
                color="primary"
                v-model="item.dataExecucao"
                @input="item.dateFormatted = formatDate(item.dataExecucao)"
                no-title
                scrollable
              ></v-date-picker>
            </v-menu>
          </template>

          <template v-slot:item.codigoTabela="{ item }">
            <div class="tabela-info"
              v-if="item.id != id_list"
              style="min-width: 150px; max-width: 150px;"
              >{{getDescricaoDominio('dm_tabela', item.codigoTabela)}}
            </div>
            
            <v-select
              v-else
              v-model="item.codigoTabela"
              :menu-props="{ bottom: true, offsetY: true }"
              dense
              :items="dominiosList[getListIndex('dm_tabela')].valores"
              item-text="descricao"
              item-value="valor"
              outlined
              class="pa-0"
              style="font-size:13px;height:30px; min-width: 150px; max-width: 150px;"
              @change="marcarLinha(item, 'examesListTable')"
            ></v-select>
          </template>

          <template v-slot:item.codigoProcedimento="{ item }">
            <span
              v-if="item.id != id_list"
              >{{ item.codigoProcedimento }}
            </span>
            <v-text-field
              v-else
              v-model="item.codigoProcedimento"
              outlined
              dense
              class="pa-0"
              style="font-size: 13px; height: 32px; margin: 8px 0px 8px"
              @change="marcarLinha(item, 'examesListTable')"
            ></v-text-field>
          </template>

          <template v-slot:item.sequencialItem="{ item }">
            <span
              v-if="item.id != id_list"
              >{{ item.sequencialItem }}
            </span>
            <v-text-field
              v-else
              v-model="item.sequencialItem"
              outlined
              dense
              class="pa-0"
              @input="comboItem()"
              style="
                font-size: 13px;
                height: 32px;
                margin: 8px 0px 8px;
               min-width: 60px;
              "
              maxlength="4"
              :rules="[formRules.typeInteger]"
              @change="marcarLinha(item, 'examesListTable')"
            ></v-text-field>
          </template>

          <template v-slot:item.descricaoProcedimento="{ item }">
            <span
              v-if="item.id != id_list"
              >{{ item.descricaoProcedimento }}
            </span>
            <v-text-field
              v-else
              v-model="item.descricaoProcedimento"
              outlined
              dense
              class="pa-0"
              style="font-size: 13px; height: 32px; margin: 8px 0px 8px"
              @change="marcarLinha(item, 'examesListTable')"
            ></v-text-field>
          </template>

          <template v-slot:item.quantidadeExecutada="{ item }">
            <span
              v-if="item.id != id_list"
              >{{ item.quantidadeExecutada }}
            </span>
            <v-text-field
              v-else
              v-model="item.quantidadeExecutada"
              @input="item.valorTotal = Number(item.valorUnitario * item.quantidadeExecutada).toFixed(2); updateInfo()"
              outlined
              dense
              class="pa-0"
              style="
                font-size: 13px;
                height: 32px;
                margin: 8px 0px 8px;
                min-width: 60px;
              "
              maxlength="3"
              :rules="[formRules.typeInteger]"
              @change="marcarLinha(item, 'examesListTable')"
            ></v-text-field>
          </template>

          <template v-slot:item.valorUnitario="{ item }">
            <span
              v-if="item.id != id_list"
              >{{ item.valorUnitario | formatPrice }}
            </span>
            <v-text-field
              v-else
              v-model.lazy="valor"
              v-money="money"
              outlined
              dense
              style="font-size: 13px; height: 32px; margin: 8px 0px 8px"
              @input="
                item.valorUnitario = valor
                  ? parseFloat(valor.replaceAll('.', '').replaceAll(',', '.'))
                  : null; item.valorTotal = Number(item.valorUnitario * item.quantidadeExecutada).toFixed(2); updateInfo()
              "
              :rules="[formRules.typeNumber]"
              @change="marcarLinha(item, 'examesListTable')"
            />
          </template>
          <template v-slot:item.valorTotal="{ item }">
            {{ Number(item.valorTotal) | formatPrice }}
          </template>
        </v-data-table>
      </v-col>
      <v-col class="pa-1" cols="4"></v-col>
      <v-col class="pa-1" cols="4">
        <v-pagination
          class="no-box-shadow"
          v-model="page"
          :length="pageCount"
        ></v-pagination>
      </v-col>
      <v-col class="pa-1" cols="4">
        <p class="text-right mt-1 mb-2" style="font-size: 15px" v-if="valorTotal!=undefined">
          <b>Total (R$): {{Number(valorTotal) | formatPrice}}</b>
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment"
import { VMoney } from "v-money"
import { dragscroll } from 'vue-dragscroll'
import { mapState } from "vuex"
export default {
  directives: { money: VMoney, dragscroll },
  data() {
    return {
      select: [],
      selectedExames: [],
      dateFormatted: null,
      date: null,
      dt: false,
      id_list: null,
      valor: null,
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false,
      },
      tabela: null,
      // headerLeft: [
      //   { text: "Data", align: "date",  value: "dataExecucao", sortable: false },
      //   { text: "Tabela", width: "1px", align:"center",  value: "codigoTabela", sortable: false, },
      // ],
      // headerCenter: [
      //   { text: "Código do Procedimento", value: "codigoProcedimento", sortable: false },
      //   { text: "Seq. do item", width: "50px", value: "sequencialItem", sortable: false },
      //   { text: "Descrição", width: "400px", value: "descricaoProcedimento", sortable: false },
      //   { text: "Conselho prof.", width: "1px", align:"center", value: "conselho", sortable: false },
      //   { text: "N° do Conselho", align:"start", value: "numeroConselhoProfissional", sortable: false },
      //   { text: "Código CBO", align:"start", value: "CBOS", sortable: false },
      //   { text: "Cód. na oper/CPF executante", width: "100px", align:"start", value: "codigoProfissional", sortable: false },
      //   { text: "Quant.", width: "1px", align:"center", value: "quantidadeExecutada", sortable: false },
      //   { text: "Valor unitário (R$)", width: "80px", align:"end", value: "valorUnitario", sortable: false },
      // ],
      // headerRight: [
      //   { text: "Valor total (R$)", align:"end",value: "valorTotal", sortable: false },
      // ],
      header: [
        { text: "Data", align: "date" ,value: "dataExecucao", sortable: false },
        { text: "Tabela", width: "1px" , align:"center", value: "codigoTabela", sortable: false, },
        { text: "Código do Procedimento", value: "codigoProcedimento", sortable: false },
        { text: "Seq. do item", align:"center" , value: "sequencialItem", sortable: false },
        { text: "Descrição", value: "descricaoProcedimento", sortable: false },
        { text: "Quant.", align:"center",value: "quantidadeExecutada", sortable: false },
        { text: "Valor unitário (R$)", width: "80px" , align:"end",value: "valorUnitario", sortable: false },
        { text: "Valor total (R$)", align:"end",value: "valorTotal", sortable: false },
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
    };
  },
  computed: {
    ...mapState({
      formRules: state => state.formRules
    }),
  },
  filters: {
    formatDate(date) {
      return moment(date).format("L");
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  mounted(){
    if(this.typeGuia=='Consulta'){
      this.header[6].text="Valor procedimento"
      this.header.splice(7, 1)
      this.header.splice(4, 2)
    }
    if(this.typeGuia=='Consulta' || !this.versaoMaior){
     this.header.splice(3, 1)
    }

  },
  methods: {
    getDescricaoDominio(tabela, valor){
      let dominioItem = this.dominiosList[this.getListIndex(tabela)].valores.find(el=> el.valor==valor)
      return dominioItem? dominioItem.descricao : 'Tabela de código '+ valor
    },
    selectLine(item) {
      this.id_list = item.id
      this.date = item.dataExecucao
      if (item.valorUnitario) {
        this.valor = (item.valorUnitario / 1).toFixed(2).toString().replace(".", ",");
        this.valor = this.valor.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },
    selecionaTodos(selection) {
      if (selection.value) {
        this.selectedExames = [...selection.items];
      } else {
        this.selectedExames = [];
      }
    },
    selecaoUnica(selection) {
      if (selection.value) {
        this.selectedExames.push(selection.item);
      } else {
        let ind = this.selectedExames.findIndex(
          (item) => item == selection.item
        );
        this.selectedExames.splice(ind, 1);
      }
    },
    marcarLinha(item, table) {
      let index = this.list.findIndex(el=> el.id == item.id)
      this.$refs[table].$el.getElementsByTagName('tbody')[0].getElementsByTagName('tr')[index].setAttribute('class', 'active')
    },
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(val);
    },
    selectedExames(item) {
      this.selected(item, 'exames')
    },
    cleanSelect(val) {
      this.select = val
      this.id_list = null
      this.page = 1
      this.$refs['examesListTable'].$el.querySelectorAll('tr').forEach(el =>el.removeAttribute('class', 'active'))
    },
  },
  props: {
    list: Array,
    valorTotal: Number,
    formatDate: Function,
    formRules: Object,
    parseDate: Function,
    selected: Function,
    cleanSelect: Array,
    deleteItems: Function,
    showopen: Function,
    updateInfo: Function,
    dominiosList: Array,
    getListIndex: Function,
    comboItem: Function,
    typeGuia: String,
    versaoMaior: Boolean
  },
};
</script>

<style>
.v-messages__message {
  font-size: 10px;
}
</style>